import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartWaterfall: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChartWaterfall"><Path d="M22 20H2V18H22V20Z" fill="currentColor"/><Path d="M5 15H3V11H5V15Z" fill="currentColor"/><Path d="M21 15H19V4H21V15Z" fill="currentColor"/><Path d="M9 13H7V6H9V13Z" fill="currentColor"/><Path d="M13 13H11V9H13V13Z" fill="currentColor"/><Path d="M17 10H15V5H17V10Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartWaterfall;
